/**
 * BillIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const BillIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M18.46 5.541c-3.57-3.57-9.35-3.57-12.91 0-3.57 3.57-3.57 9.35 0 12.91 3.57 3.57 9.35 3.57 12.91 0s3.57-9.35 0-12.91M4.22 4.221c4.3-4.29 11.26-4.29 15.56 0 4.3 4.3 4.3 11.26 0 15.56s-11.26 4.3-15.56 0c-4.29-4.3-4.29-11.26 0-15.56m7.78.14c.52 0 .93.42.93.93v.74c1.86.05 3.36 1.58 3.36 3.45 0 .52-.42.93-.93.93s-.93-.42-.93-.93c0-.87-.71-1.58-1.58-1.58h-1.84a1.421 1.421 0 0 0-.34 2.8l3.14.79c1.46.37 2.49 1.68 2.49 3.19 0 1.82-1.47 3.29-3.29 3.29h-.07v.74c0 .52-.42.93-.93.93s-.93-.42-.93-.93v-.74a3.45 3.45 0 0 1-3.35-3.45c0-.52.42-.93.93-.93s.93.42.93.93c0 .87.71 1.58 1.58 1.58H13a1.421 1.421 0 0 0 .34-2.8l-3.14-.79a3.294 3.294 0 0 1-2.49-3.19c0-1.82 1.47-3.29 3.29-3.29h.06v-.74c0-.52.42-.93.93-.93z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const BillIcon = makeIcon('BillIcon', BillIconSvg)
